module.exports = __webpack_public_path__ + "static/media/SuccessSendVolumeIcon.bdaf024c.svg";